import React from "react";
import { useSearchParams } from "react-router-dom";
import { RecordsTable } from "dyl-components";
import { CallHistoryLogHeader } from "./Header";
import CallHistoryRow from "./Row";
import { useSelector } from "react-redux";

const CallHistoryLogTable = ({
    isColumnHidden,
    onPageChange,
    onEditLog,
    onAddContact,
    onMarkVoicemail,
    onReportCall,
}) => {
    const { count, isLoading, data } = useSelector((state) => ({
        count: state?.call_history?.call_history?.count,
        isLoading: state?.call_history?.isReadingCallHistory,
        data: state?.call_history?.call_history?.data,
    }));
    const [params] = useSearchParams();

    return (
        <RecordsTable
            tableBodyClassName="CallHistoryTable"
            isTableLoading={isLoading}
            isSearchResultEmpty={
                !count && (params.get("search") || params?.get("phone"))
            }
            isTableEmpty={
                !count && !(params.get("search") || params?.get("phone"))
            }
            TableHeader={
                <CallHistoryLogHeader isColumnHidden={isColumnHidden} />
            }
            TableRows={data?.map?.((call) => (
                <CallHistoryRow
                    key={call?.call_uuid}
                    entry={call}
                    isColumnHidden={isColumnHidden}
                    onEditLog={onEditLog}
                    onAddContact={onAddContact}
                    onMarkVoicemail={onMarkVoicemail}
                    onReportCall={onReportCall}
                />
            ))}
            recordsCount={count}
            activePage={params.get("page")}
            onPageChange={onPageChange}
            recordsName="Call History Logs"
            emptySubtitle=" "
            emptyListTitle="No Calls Added"
        />
    );
};

export default CallHistoryLogTable;
